import HttpDRService from "./httpdr.service";

class RefreshService {
    // Accepts platform, an optional array of profile IDs, optional single ID, and optional refresh type
    async refreshProfile(platform, profileIds = [], id = "", refreshType = "") {
        try {
          let endpoint = id
            ? `/platform/${platform.toLowerCase()}/refresh/${id}`
            : `/platform/${platform.toLowerCase()}/refresh`;
  
          const queryParams = [];
  
          if (!id && Array.isArray(profileIds) && profileIds.length > 0) {
            const idsParam = profileIds.join(",");
            queryParams.push(`profile_ids=${idsParam}`);
          }
  
          if (refreshType) {
            queryParams.push(`refresh_type=${refreshType}`);
          }
  
          if (queryParams.length > 0) {
            endpoint += `?${queryParams.join("&")}`;
          }
  
          const response = await HttpDRService.get(endpoint);
          return response;
        } catch (error) {
          console.error("Error refreshing profiles:", error);
          throw error;
        }
      }
    }

    export default new RefreshService();